import React from 'react';

import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { permissions } from '@vlabs/shared/config';
import { useFaceOcclusionIsAvailable } from '@vlabs/shared/hooks';
import {
  Divider, Grid, GridRow, GridCol, Fold,
} from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  AttributesPolicySubForm,
  EventPolicySubForm,
  FacePolicySubForm,
  FaceSamplePolicySubForm,
  BodySamplePolicySubForm,
  NotificationPolicySubForm,
  CommonSubForm,
  EstimationsFaceSubForm,
  EstimationsBodySubForm,
  FiltersSubForm,
  MatchPolicySubForm,
  TagPolicySubForm,
  ImageOriginPolicySubForm,
  CallbacksPolicySubForm,
  PeopleCountSubForm,
  LivenessSubForm,
  FaceOcclusionSubForm,
} from '@vlabs/pages/handlers/forms';

import { DeepfakeSubForm } from './forms/DeepfakeSubForm';
import FaceQualitySubForm from './forms/FaceQualitySubForm';

import './EditHandlerForm.sass';
import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';

export function EditHandlerForm({
  onSubmit,
  values,
  handlerOptions,
  listOptions,
}) {
  const { t } = useTranslation();
  const formMethods = useForm({ defaultValues: values });
  const { handleSubmit } = formMethods;

  // FIXME временное решение, в будущем добавлять StepFaceOcclusion по умолчанию
  const isFaceOcclusionAvailable = useFaceOcclusionIsAvailable();

  const onAction = (
    <ButtonWithPermissions
      permissions={{ rules: [permissions.handler.modification] }}
      type="submit"
      variant="outlined"
    >
      {t('btn.save')}
    </ButtonWithPermissions>
  );

  const context = {
    ...formMethods,
    listOptions,
    handlerOptions,
  };

  return (
    <FormProvider {...context}>
      <Page>
        <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 1 }}>
          <PageContent>
          <PageHeader
            actions={onAction}
            title={t('handlers:edit page.title')}
          />
          <Grid>
            <GridRow>
              <GridCol cols={6}>
                <Fold
                  isOpen
                  testId="commonSection"
                  title={t('handlers:setup sections.general')}
                >
                  <CommonSubForm />
                </Fold>
                <Divider />
                {!values.isDynamic && (
                  <React.Fragment>
                    <Fold
                      isOpen
                      testId="faceAttributes"
                      title={t('handlers:setup sections.determined face attributes')}
                    >
                      <EstimationsFaceSubForm />
                    </Fold>
                    <Divider />

                    <LivenessSubForm />
                    <Divider />

                    <DeepfakeSubForm />
                    <Divider />

                    <FaceQualitySubForm />
                    <Divider />

                    {!!isFaceOcclusionAvailable && (
                    <React.Fragment>
                      <FaceOcclusionSubForm />
                      <Divider />
                    </React.Fragment>
                    )}

                    <Fold
                      isOpen
                      testId="bodyAttributes"
                      title={t('handlers:setup sections.determined body attributes')}
                    >
                      <EstimationsBodySubForm />
                    </Fold>
                    <Divider />

                    <PeopleCountSubForm />
                    <Divider />

                    <Fold
                      isOpen
                      testId="filtersSection"
                      title={t('handlers:setup sections.filters')}
                    >
                      <FiltersSubForm />
                    </Fold>
                    <Divider />

                    <Fold
                      isOpen
                      testId="matchPolicy"
                      title={t('handlers:setup sections.labels')}
                    >
                      <MatchPolicySubForm />
                    </Fold>

                  </React.Fragment>
                )}

              </GridCol>

              {!values.isDynamic && (
                <GridCol cols={6}>
                  <FaceSamplePolicySubForm />
                  <Divider />
                  <BodySamplePolicySubForm />
                  <Divider />
                  {/* TODO: Разобраться с неймингом */}
                  <AttributesPolicySubForm />
                  <Divider />
                  <ImageOriginPolicySubForm />
                  <Divider />
                  <FacePolicySubForm />
                  <Divider />
                  <EventPolicySubForm />
                  <Divider />
                  <NotificationPolicySubForm />
                  <Divider />
                  <Fold
                    isOpen
                    testId="tagPolicy"
                    title={t('handlers:setup sections.tagging parameters')}
                  >
                    <TagPolicySubForm />
                  </Fold>
                  <Divider />
                  <Fold
                    isOpen
                    testId="callbacksPolicy"
                    title={t('handlers:setup sections.callbacks')}
                  >
                    <CallbacksPolicySubForm />
                  </Fold>
                </GridCol>
              )}
            </GridRow>
          </Grid>
          </PageContent>
        </form>
      </Page>
    </FormProvider>
  );
}

EditHandlerForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  can: PropTypes.func.isRequired,
  values: PropTypes.objectOf(PropTypes.any),
  handlerOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  listOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
};

EditHandlerForm.defaultProps = {
  values: undefined,
  handlerOptions: [],
  listOptions: [],
};
